<template>
  <div>
    <navBar></navBar>
    <div class="main">
      <van-row>
        <van-col :span="24">
          <span>头像</span>
          <div class="photo">
            <van-uploader :after-read="afterRead" />
            <img class="photo" :src="form.avatar" alt="" />
          </div>
        </van-col>
        <van-col :span="24">
          <span>昵称</span>
          <van-field
            v-model="form.nickname"
            label=""
            placeholder="请输入昵称"
            input-align="right"
          />
        </van-col>
      </van-row>
      <van-button class="btns" round @click="save">保存</van-button>
    </div>
  </div>
</template>
  <script>
  import { Toast } from "vant";
import navBar from "@/components/navBar.vue";
import { getuserinfo, uploadphoto, saveuserinfo } from "@/api/home";
export default {
  components: {
    navBar,
  },
  data() {
    return {
      userinfo: null,
      form: {
        avatar: null,
        nickname: null,
      },
      fileList: null,
    };
  },
  methods: {
    getinfo() {
      getuserinfo().then((res) => {
        // console.log(res);
        this.form.avatar = res.avatar;
        this.form.nickname = res.nickname;
      });
    },
    afterRead(file) {
      // console.log(file.file);
      const data = new FormData();
      data.append("file", file.file);
      uploadphoto(data).then((res) => {
        console.log(res);
        this.form.avatar = res.data.url;
      });
    },
    save() {
      saveuserinfo(this.form).then((res) => {
        Toast.success(res.message);
      });
    },
  },
  created() {
    this.getinfo();
  },
};
</script>
  <style lang="scss" scoped>
.main {
  margin-top: 46px;
  padding: 0 18px;
  .van-col {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f2f0f0;
    padding: 15px;
    font-size: 14px;
    span {
      width: 32px;
    }
    .photo {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-top: 5px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .van-uploader {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        :deep .van-uploader__upload {
          background: none !important;
        }
        :deep .van-uploader__upload-icon {
          display: none;
        }
      }
    }
  }
  .btns {
    width: calc(100% - 36px);
    position: fixed;
    bottom: 32px;
    left: 18px;
    box-sizing: border-box;
    background: #2553e2;
    color: #fff;
  }
}
</style>